
import { BasicInfo } from './FormSlides/BasicInformation';
import { InterestsActivitiesGoals } from './FormSlides/InterestsActivitiesGoals';
import { Confirmation } from './FormSlides/Confirmation';
import { FormWrapper } from '../../../components/Additional/FormWrapper';
import { AuthContext } from '../../../components/AuthWrapper';
import { Navigate, useNavigate, useOutletContext } from 'react-router-dom';
import { NotSignedIn } from '../../../components/NotAuthorized/NotSignedIn';
import PageTitle from '../../../components/PageTitle';
import { SkeletonLoader } from '../../../components/NotAuthorized/SkeletonLoader';
import { useEffect } from 'react';

type FormPageSourceType = "onboard" | "edit";

interface FormPageProps {
  source: FormPageSourceType;
}

export function FormPage({source}: FormPageProps): JSX.Element {
  const { student, state, loggedIn }: AuthContext = useOutletContext();

  const navigate = useNavigate();

  if (!loggedIn) return <NotSignedIn />;
  if (!state.user) return <SkeletonLoader />;

  useEffect(() => {
    if (source === "edit") return; // if editing and not onboarding, then no redirecting

    // Redirect if student has already completed onboarding
    if (student) {
      console.warn('Student has already completed onboarding!');
      navigate(`/Profile/${student.id}`);
    }
  }, [student]);

  return (
    <>
      <PageTitle title="Student Profile" />
      <div id="slides">
        <FormWrapper pages={PageMap} width="narrow" />
      </div>
    </>
  );
};

const enum Page {
  BasicInfo,
  InterestsActivitiesGoals,
  Confirmation
}
const PageMap = new Map([
  [Page.BasicInfo, { index: 1, node: <BasicInfo /> }],
  [Page.InterestsActivitiesGoals, { index: 2, node: <InterestsActivitiesGoals /> }],
  [Page.Confirmation, { index: 3, node: <Confirmation /> }]
])

